import React from 'react'

const AboutUsPage = () => {
    return (
        <div>
            <h1>About Indigo Scales</h1>
        </div>
    )
}

export default AboutUsPage
